import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class MachinesGroupsApi extends ApiModule {
	constructor() {
		super(ModulesMap.MACHINES_GROUPS, {
			entity: 'machines_groups',
		})
	}
}
